import { cn } from "@util/helpers";

import ThriveSubscriptionForm from "./ThriveSubscriptionForm";

type ThriveCenterSubscriptionProps = {
  title?: string;
  description?: string;
  className?: string;
  subscriptionFormClassName?: string;
};

export default function ThriveCenterSubscription({
  title = "Maximise your time.",
  description = "The good stuff on work and money, every Friday.",
  className,
  subscriptionFormClassName,
}: ThriveCenterSubscriptionProps): React.ReactElement {
  return (
    <div
      className={cn("relative overflow-hidden py-10 text-center", className)}
      data-testid="thrive-center-subscription-component"
    >
      <div className="relative -ml-2 w-[101vw] -rotate-2 border-y-2 border-black bg-white pb-60 pt-56"></div>

      <div className="absolute left-1/2 top-1/2 w-full -translate-x-1/2 -translate-y-1/2 p-10 text-center lg:w-auto lg:p-20">
        <p className="m-0 p-0 text-7xl lg:text-9xl">{title}</p>

        <p className="mt-0 p-0">{description}</p>

        <ThriveSubscriptionForm
          className={cn(
            "mx-auto mt-4 w-full border border-black bg-white shadow-thriveButton transition-all duration-150 hover:shadow-thriveNewsletterHover lg:w-fit",
            subscriptionFormClassName
          )}
        />
      </div>
    </div>
  );
}
